<template>
  <v-container grid-list-xs class="pa-0 ma-0 px-2" fluid>
    <v-row class="pa-0 ma-0 titlesdark--text">
      <v-col md="8" sm="12" class="pa-0 ma-0 mt-1">
        <span class="pl-1 text-light font-size-2">Licencias Activas</span>
      </v-col>
       <v-col md="12" sm="12" cols="12" class="pa-0 ma-0">
        <v-breadcrumbs
          class="py-2 px-0"
          :items="aItemsBreadcrumbs"
          divider=">"
        >
         <template v-slot:item="{ item }">
          <v-breadcrumbs-item class="titlesdark--text">
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
        </v-breadcrumbs>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="12" md="3" lg="3" xl="3" v-for="(item, index) in aWidget" :key="index+nKeyGeneral">
        <v-card elevation="1" :class="aLicencias[index].idLicencias == type ? 'border-primary' : '' ">
          <v-card-text>
            <Widget
              :sTitulo="$store.state.jsIdioma.oEquivalencias.cmpNoLicencias + ` ${aLicencias[index].Tipo}` "
              sLabel="Total"
              :aData="item"
            />
            <div class="d-flex justify-end mt-2">
              <v-btn x-small color="primary" rounded @click="onCargarLicenciasClienteEspecifico(parseInt(aLicencias[index].tipo_id))" >
                <v-icon left x-small>mdi-account-tie-voice</v-icon>
                Filtrar
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row no-gutters v-if="nIdClienteLicencias!=-1">
      <v-col >
        <v-card elevation="0">
          <v-card-text>
            <ExportarLicencias :bModalDescargas="bModalDescargas" @onClose="onClose" :oArchivos="oArchivos"/>
            <h3 class="ml-4">
                <v-btn icon color="primary" @click="onVolver()">
                  <v-icon>mdi-arrow-left-bold-circle</v-icon>
                </v-btn>
                Licencias Activas de: <span class="ml-2">{{ sNombreCliente }}</span> </h3>
            <DataTable :columns="cpmHeaders" :data="aItem" bFilter :key="nKeyRefresh" @onDataFromApi="onBlur" bExportar>
              <template #btn_exportar>
                <v-btn color="primary" @click="onExportar" rounded :loading="bLoadingExportar" :disabled="bLoadingExportar">
                  <v-icon>mdi-download</v-icon>
                  Exportar
                </v-btn>
              </template>
            </DataTable>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- <v-col v-else>
        <EmptyView />
      </v-col> -->
    </v-row>
    
  </v-container>
</template>

<script>
import ExportarLicencias from '@/views/Licencias/components/ExportarLicencias.vue';
import  axiosServices  from '@/services/axiosServices.js';
import DataTable from '@/components/Grid/CustomGrid.vue';
import Widget from "@/views/Licencias/Widget/WidgetBase.vue";

export default {
  name:"LicenciasCliente",
  components: {
    ExportarLicencias,
    DataTable,
    Widget
  },
  data() {
    return {
      nKeyRefresh:0,
      aItem: [],
      aItemsBreadcrumbs: [
        {
          text: 'Inicio',
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Control de licencias',
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Licencias Activas',
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
      ],
      bModalDescargas:false,
      bLoadingExportar: false,
      oArchivos:{},
      nIdClienteLicencias:-1,
      sNombreCliente:"",
      aWidget: [],
      nKeyGeneral:0,
      aLicencias:[],
      type: -1,
    }
  },
  async created() {
        this.nIdClienteLicencias = this.$route?.params?.id;
        await this.onCargarLicenciasClienteEspecifico(-1);
  },
  methods: {
    onClose() {
      this.bModalDescargas = false;
    },
    onBlur() {
      this.nKeyRefresh++
    },
    async onExportar() {
      try {
        // Limpiar archivos previos
        this.oArchivos = {};

        this.bLoadingExportar = true;

        const sParams = "idCliente="+this.nIdClienteLicencias+'&tipo=' + this.type
        const { nStatusCode, aData } = await axiosServices.postConfiguration(`licencias/exportar`, {} , true, sParams)
        if (nStatusCode === 200) {
          this.oArchivos = aData;
          this.bModalDescargas = true;
        }
        this.bLoadingExportar = false;
      } catch (error) {
        this.bLoadingExportar = false;
      }
    },
    async onCargarLicenciasClienteEspecifico(tipo){
        try {
            if(typeof tipo === "number") {
                this.type = parseInt(tipo) !== this.type ? parseInt(tipo) : -1
            }
            const { nStatusCode, aData } = await axiosServices.getConfiguration(`licenciasClienteId`, true, "idCliente="+this.nIdClienteLicencias+`&tipo=${this.type}`)
            if (nStatusCode === 200) {          
                this.aItem = []
                this.aItem = aData.aLicencias;
                this.sNombreCliente = aData.sCliente;
                this.aWidget = aData.aContadores.map(({ NoLicencias, Conteo }) => [
                    ["Total", "Disponibles", "En uso"],
                    [ 
                    parseInt(NoLicencias) === -1 ? 'N/A' : NoLicencias, 
                    parseInt(NoLicencias) > 0 ? parseInt(NoLicencias) - parseInt(Conteo) : 'N/A',
                    parseInt(Conteo)
                    ]
                ]); 
                this.nKeyRefresh++
                this.aLicencias = aData.aContadores
            }
        } catch (error) {
            error
        }
    },
    onVolver(){
      this.$router.push({ name: 'AdministracionLicencias'});
    }
  },
  computed: {
    cpmHeaders() {
        return [
            {
                text: this.$store.state.jsIdioma.oEquivalencias.cmpNombreUsuario,
                sortable: true,
                class: "titlesdark--text font-titulo text-medium",
                value: "NombreUsuario",
            },
            {
                text: this.$store.state.jsIdioma.oEquivalencias.cmpUsuario,
                sortable: true,
                class: "titlesdark--text font-titulo text-medium",
                value: "login_log",
            },
            {
                text: this.$store.state.jsIdioma.oEquivalencias.cmpTipoConexion,
                sortable: true,
                class: "titlesdark--text font-titulo text-medium",
                value: "tipo",
            },
            {
                text: this.$store.state.jsIdioma.oEquivalencias.cmpOrigen,
                sortable: true,
                class: "titlesdark--text font-titulo text-medium",
                value: "proyecto",
            },
            {
                text: this.$store.state.jsIdioma.oEquivalencias.cmpFechaUltimaConexion,
                sortable: true,
                class: "titlesdark--text font-titulo text-medium",
                value: "FechaRegistro",
            },
            {
                text: this.$store.state.jsIdioma.oEquivalencias.cmpVersion,
                sortable: true,
                class: "titlesdark--text font-titulo text-medium",
                value: "Version",
            },
        ];
    }
  },
}
</script>
<style scoped>
.border-primary {
  border: 1px solid #3C74B6 !important;
}
</style>